import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import logo from '../../images/logo-baccredomatic.svg'
import logoPricesmart from '../../images/logo-pricesmart.svg'

const OuterContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #ddd;
`

const LogosContainer = styled.div`
  display: flex;
  padding: 0 20px;
  margin-bottom: 20px;

  ${breakpoint('desktop')`
    padding: 0;
    margin-bottom: 60px;
  `}

  & > div {
    flex-basis: 50%;
  }

  & > div:last-of-type {
    text-align: right;
  }

  img {
    max-width: 120px;

    ${breakpoint('tablet')`
      max-width: 150px;
    `}
  }
`

const Copyright = styled.div`
  font-size: 12px;
  margin-bottom: 40px;
  color: ${props => props.theme.colors.amexGrisTexto};
  text-align: center;
`

export default () => {
  return (
    <OuterContainer>
      <LogosContainer>
        <div>
          <img src={logoPricesmart} alt="PriceSmart" />
        </div>
        <div>
          <img src={logo} alt="BAC Credomatic" />
        </div>
      </LogosContainer>
      <Copyright>
        TODOS LOS DERECHOS RESERVADOS. {new Date().getFullYear()} © BAC
        INTERNATIONAL BANK
      </Copyright>
    </OuterContainer>
  )
}
